/**
------------------------------------------------------------------------------------------------------------------------------------------
THEME-SPECIFIC CONSTANTS
------------------------------------------------------------------------------------------------------------------------------------------
*/

import { SITE_NAME } from './constants';

export const THEME_DIRECTORY = `wp-content/themes/${SITE_NAME}-theme`;
//export const THEME_HOST = `test`;
export const THEME_PORT = 5173;

export const enum CSSBreakpoint {
	XS = 0,
	SM = 375,
	MD = 834,
	Desktop = 1024,
	LG = 1500,
}

export enum CSSClass {
	CurrentMenuParent = 'current-menu-parent',
	CurrentMenuItem = 'current-menu-item',
	MenuItem = 'menu-item',
	MenuHorizontalItemsList = 'menu-horizontal-items-list',
	SubMenu = 'sub-menu',
	ExpandSubMenu = 'expand-sub-menu',
	MenuItemHasChildren = 'menu-item-has-children',
}
